import request from "./request";
import axios from "axios";

export const getGeocode = (address) =>
  axios.get(
    `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURI(
      address
    )}&key=AIzaSyDA4QOUj1QyMYJHRV3F5DPquJkbNVPpKy0`
  );

export const getReverseGeocode = (latlng) =>
  axios.get(
    `https://maps.googleapis.com/maps/api/geocode/json?latlng=${encodeURI(
      latlng
    )}&key=AIzaSyDA4QOUj1QyMYJHRV3F5DPquJkbNVPpKy0`
  );

export const updateLocation = (id, values) =>
  request({ url: `/locations/${id}`, method: "put", data: values });

export const createLocation = (data) => {
  let url = data.id ? `/locations/${data.id}` : `/locations`;
  let method = data.id ? `put` : `post`;

  return request({ url: url, data: data, method: method });
};
